import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { AppWrapper } from 'components';
import AffiliateBusinessSelector from 'components/AffiliateBusinessSelector/AffiliateBusinessSelector';
import AffiliateCouponsList from 'components/AffiliateCouponsList/AffiliateCouponsList';
import AffiliateCustomCoupon from 'components/AffiliateCustomCoupon/AffiliateCustomCoupon';
import Breadcrumbs from 'components/BreadCrumbs/BreadCrumbs';
import Pagination from 'components/Pagination/Pagination';
import ProductsStatus from 'components/ProductsStatus/ProductsStatus';
import {
  AFFILIATE_TYPES,
  COUPON_EXPIRY_TYPES,
  COUPON_STATES,
  COUPON_TYPES} from 'coupon-common';
import { actions as affiliateActions } from 'coupon-common/src/modules/affiliateBusiness';
import { actions as awinActions } from 'coupon-common/src/modules/awin';
import { actions as businessCategoriesActions } from 'coupon-common/src/modules/businessCategories';
import { parseISOString } from 'coupon-common/src/utils';

const AwinOffersFetcher = () => {
  const dispatch = useDispatch();
  const AFFILIATE_TYPE = AFFILIATE_TYPES.awin;

  const affiliateBusinesses = useSelector((state) => state.affiliateBusiness?.data?.results || []);
  const awinBusinesses = useSelector((state) => state.awin.businesses || []);
  const awinPromotions = useSelector((state) => state.awin.promotions || []);
  const awinLoading = useSelector((state) => state.awin.loading);

  const [inputValue, setInputValue] = useState('');
  const [productsRequested, setProductsRequested] = useState(false);
  const [filteredPromotions, setFilteredPromotions] = useState([]);
  const [displayedCoupons, setDisplayedCoupons] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedBusinessId, setSelectedBusinessId] = useState();
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 10;
  const [firstProductIndex, setFirstProductIndex] = useState(1);
  const [lastProductIndex, setLastProductIndex] = useState(10);

  const [showCustomCoupon, setShowCustomCoupon] = useState(false);

  useEffect(() => {
    dispatch(awinActions.getBusinesses());
    dispatch(affiliateActions.getAffiliateBusinesses());
    dispatch(businessCategoriesActions.getBusinessCategories());
  }, [dispatch]);

  // When promotions load after button click, filter to the selected advertiser
  useEffect(() => {
    if (!productsRequested || !inputValue) return;

    const filtered = awinPromotions.filter(
      (p) => String(p.advertiser?.id) === String(inputValue)
    );
    setFilteredPromotions(filtered);
    setCurrentPage(1);
    setLoading(false);
  }, [awinPromotions]);




  useEffect(() => {
    if (!productsRequested || !inputValue) return;

    const filtered = awinPromotions.filter(
      (p) => String(p.advertiser?.id) === String(inputValue)
    );

    // TEMP DEBUG — remove after inspecting shape
    const sampleVoucher = filtered.find((p) => p.type === 'voucher');
    const sampleOffer = filtered.find((p) => p.type !== 'voucher');
    // console.log('AWIN sample voucher:', JSON.stringify(sampleVoucher, null, 2));
    // console.log('AWIN sample offer:', JSON.stringify(sampleOffer, null, 2));

    setFilteredPromotions(filtered);
    setCurrentPage(1);
    setLoading(false);
  }, [awinPromotions]);

const mapPromotionToCoupon = (promotion, index) => {
  const isVoucher = promotion.type === 'voucher';
  const voucher = promotion.voucher || {};
  // The AWIN API doesn't provide any discount related information yet so no discount calculation is being performed on our end.
  let type = COUPON_TYPES.PERCENTAGE_OFF;
  let percentage_off;
  let amount_off;
  let coupon_code;

  if (isVoucher) {
    type = COUPON_TYPES.COUPON_CODE;
    coupon_code = voucher.code || '';
  }

  const parsedStart = promotion.startDate ? parseISOString(promotion.startDate) : null;
  const parsedEnd = promotion.endDate ? parseISOString(promotion.endDate) : null;

  return {
    localId: `local-${Date.now()}-${index}`,
    title: promotion.title || '',
    description: promotion.description || '',
    terms: promotion.terms || '',
    type,
    percentage_off,
    amount_off,
    coupon_code,
    published_at: parsedStart,
    expiration_date: parsedEnd,
    start_date: parsedStart,
    expiry_type: parsedEnd ? COUPON_EXPIRY_TYPES.DATE : COUPON_EXPIRY_TYPES.AMOUNT_LIMIT,
    expiration_quantity: parsedEnd ? undefined : 1000,
    link_url: promotion.urlTracking || promotion.url || '',
    affiliate_link: promotion.urlTracking || promotion.url || '',
    image_url: [],
    deal: true,
    state: COUPON_STATES.PUBLISHED,
    auto_accept: true,
    is_affiliate_or_flyer: true,
  };
};

  const resetData = () => {
    setFilteredPromotions([]);
    setDisplayedCoupons([]);
  };

  const handleFetchProducts = () => {
    setShowCustomCoupon(false);
    setProductsRequested(true);
    setLoading(true);
    dispatch(awinActions.getPromotions(inputValue));
  };

  useEffect(() => {
    const lastPostIndex = currentPage * postsPerPage;
    const firstPostIndex = lastPostIndex - postsPerPage;

    setFirstProductIndex(firstPostIndex + 1);
    setLastProductIndex(lastPostIndex);

    const currentSlice = filteredPromotions
      .slice(firstPostIndex, lastPostIndex)
      .map((promo, index) => mapPromotionToCoupon(promo, index));

    setDisplayedCoupons(currentSlice);
  }, [currentPage, filteredPromotions]);

  const handleReset = () => {
    if (showCustomCoupon) {
      resetData();
      setProductsRequested(false);
      setShowCustomCoupon(false);
    }
  };

  const handleCustomCoupon = () => {
    resetData();
    setShowCustomCoupon(true);
  };

  return (
    <AppWrapper showHeader showSideNav showHeadingRow headingText="🎯 Awin Coupon & Product Tool">
      <div className="col-md-12">
        <Breadcrumbs locationArray={['Admin', 'Awin Import']} />

        <AffiliateBusinessSelector
          affiliateProgramLoading={awinLoading}
          affiliateBusinesses={affiliateBusinesses}
          affiliateProgramBusinesses={awinBusinesses}
          affiliateType={AFFILIATE_TYPE}
          inputValue={inputValue}
          onInputValueChange={setInputValue}
          selectedBusiness={selectedBusiness}
          productsRequested={productsRequested}
          onProductsRequestedChange={setProductsRequested}
          onSelectedBusinessIdChange={setSelectedBusinessId}
          onSelectedBusinessChange={setSelectedBusiness}
          handleFetchProducts={handleFetchProducts}
          OnShowCustomCoupon={handleCustomCoupon}
        />

        {inputValue && productsRequested && (
          <div>
            {showCustomCoupon ? (
              <AffiliateCustomCoupon
                affiliateBusinesses={affiliateBusinesses}
                selectedBusinessId={selectedBusinessId}
                dispatch={dispatch}
                inputValue={inputValue}
                onClose={handleReset}
              />
            ) : (
              <>
                <ProductsStatus
                  title="🎟️ Active Promotions & Vouchers"
                  items={filteredPromotions}
                  firstIndex={firstProductIndex}
                  lastIndex={lastProductIndex}
                  loading={loading}
                  displayedItems={displayedCoupons}
                />

                <Pagination
                  totalPosts={filteredPromotions.length}
                  postsPerPage={postsPerPage}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                />

                <AffiliateCouponsList
                  coupons={displayedCoupons}
                  loading={loading}
                  affiliateBusinesses={affiliateBusinesses}
                  selectedBusinessId={selectedBusinessId}
                  inputValue={inputValue}
                  dispatch={dispatch}
                  // handleRemove={handleRemove}
                  selectedBusiness={selectedBusiness}
                  showDealFields={true}
                  defaultCategory={selectedBusiness?.categories?.[0] || null}
                />
              </>
            )}
          </div>
        )}
      </div>
    </AppWrapper>
  );
};

export default AwinOffersFetcher;